import { FilterAutocomplete } from '../baseInputTypes/FilterAutocomplete'

type Props = {}
export const Sources = (props: Props) => (
  <FilterAutocomplete
    label="Sources"
    fieldName={'sources'}
    fieldPath={'productInformation.sources'}
  />
)
